import hydrate from '../common/hydrate';
import TrustIcons from './components/TrustIcons';
import { root, name } from './manifest.json';
hydrate(TrustIcons, root, name);
if (module.hot) {
    module.hot.accept();
}
